import styled from "styled-components";
import Box from "../Box";
import { Colors, OUTLET_TYPES } from "../../config/Constants";
import Textfield from "../Merchant/Textfield";
import Selectfield from "../Merchant/Selectfield";
import Button from "../Button";
import TextfieldWithImage from "./TextFieldWithImage";
import UploadOutletImages from "./UploadOutletImages";
import TextArea from "./TextArea";
import countryCodeData from "../../pages/AddOutlet/countries";
import Toggle from "../Toggle";
import { InfoWrapper, StyledDiv } from "../../pages/AddOutlet";
import Radio from "../Radio";
import { useEffect, useState } from "react";
import InfoAndText from "./InfoAndText";
import MultiDateSelector from "../MultiDateSelector";
import Datefield from "../Events/Datefield";
import Checkbox from "../Checkbox";
import MultiTagSelector from "../ManageOutlet/MultiTagSelector";

interface StatusProps {
  status: boolean;
  statusType?: string;
}
interface Props {
  id: string | undefined;
  onSubmit: () => void;
  onChange: (
    event:
      | any
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
  onCancel: () => void;
  onRemove: (e: any) => void;
  onToggleTagOption: (e?: any) => void;
  onToggleSelectAllTags: (e?: any) => void;
  onSetUrls: (e?: any) => void;
  value: {
    tags: string[];
    outletName: string;
    outletType: string;
    email: string;
    countryCode: string;
    phoneNumber: string;
    outletInfo: string;
    whatsappNumber: string;
    instaLink: string;
    fbLink: string;
    lat: string;
    long: string;
    address: string;
    shortName: string;
    tripAdvisor: string;
    maxGuest: string;
    venueId: string;
    sevenRoomCountryCode: string;
    sevenRoomWhatsapp: string;
    sevenRoomContact: string;
    logoUrl: string[];
    imageUrl: string[];
    bannerImageUrl: string[];
    iFrameUrl: string;
    specialProductsDates: string[];
    holidayAllowedDates: string[];
    restrictedDates: string[];
    startDate: string;
    endDate: string;
    isLoyaltyEnabled: boolean;
    posConfigtenderMediaLoyalty: string;
    posConfigUrl: string;
    posConfigempId: string;
    posConfigrevCenter: string;
    loyaltyTypes: string[];
    notificationEmail: string;
    surveyLink: string;
    receiptMerchantName: string;
    costCenter: string;
    companyCode: string;
    tcLink: string;
    ppLink: string;
    order: string;
    taxType: string;
    trn: string;
    tin: string;
    groupTrn: string;
    crNumber: string;
    taxStartDate: string;
    isInclusiveVAT: boolean;
    isTaxEnabled: boolean;
  };
  error: {
    tags: string;
    outletName: string;
    outletType: string;
    email: string;
    countryCode: string;
    phoneNumber: string;
    outletInfo: string;
    whatsappNumber: string;
    instaLink: string;
    fbLink: string;
    lat: string;
    long: string;
    address: string;
    shortName: string;
    tripAdvisor: string;
    maxGuest: string;
    venueId: string;
    sevenRoomWhatsapp: string;
    sevenRoomContact: string;
    logoUrl: string;
    imageUrl: string;
    bannerImageUrl: string;
    iFrameUrl: string;
    specialProductsDates: string;
    holidayAllowedDates: string;
    restrictedDates: string;
    startDate: string;
    endDate: string;
    posConfigtenderMediaLoyalty: string;
    posConfigUrl: string;
    posConfigempId: string;
    posConfigrevCenter: string;
    loyaltyTypes: string;
    notificationEmail: string;
    surveyLink: string;
    receiptMerchantName: string;
    costCenter: string;
    companyCode: string;
    tcLink: string;
    ppLink: string;
    order: string;
    taxType: string;
    trn: string;
    tin: string;
    groupTrn: string;
    crNumber: string;
    taxStartDate: string;
    isInclusiveVAT: string;
    isTaxEnabled: string;
  };
  uploadedImage: any;
  reservationStatus: boolean;
  reservationToggle: () => void;
  isSevenRoomBooking: boolean;
  setIsSevenRoomBooking: (a: boolean) => void;
  isIFrameBooking: boolean;
  setIsIFrameBooking: (a: boolean) => void;
  setIfLoyaltyEnabled: (a: boolean) => void;
  onLoyaltyTypeChange: (a: string) => void;
  outletTags: any;
  taxConfigList:any
}

const AddOutletForm = ({
  id,
  onSubmit,
  onCancel,
  onChange,
  onRemove,
  value,
  error,
  uploadedImage,
  reservationStatus,
  reservationToggle,
  isSevenRoomBooking,
  setIsSevenRoomBooking,
  isIFrameBooking,
  setIsIFrameBooking,
  setIfLoyaltyEnabled,
  onLoyaltyTypeChange,
  outletTags,
  onToggleTagOption,
  onToggleSelectAllTags,
  onSetUrls,
  taxConfigList
}: Props) => {
  function getFlagName(countryCode: string) {
    let newArr = countryCodeData.filter(
      (eachData) => eachData.callingCode === countryCode
    );
    if (newArr.length) return newArr[0].flag;
    else return require(`../../assets/images/flags/qa.png`);
  }
  const initValue = [false, false];
  const [isSelectedRadio, setIsSelectedRadio] = useState<boolean[]>([]);
  const handleRadio = (selectedRadio: boolean, index: number) => {
    let newArr = [...initValue];
    newArr[index] = selectedRadio;
    setIsSelectedRadio(newArr);
    setIsSevenRoomBooking(newArr[0]);
  };
  useEffect(() => {
    setIsSelectedRadio([isSevenRoomBooking, !isSevenRoomBooking]);
  }, [isSevenRoomBooking]);
  return (
    <Container>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="outletName"
                label="Outlet Name"
                placeholder="Enter Outlet Name"
                onChange={onChange}
                value={value.outletName}
                required
                helperText={error["outletName"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Selectfield
                name="outletType"
                label="Outlet Type"
                onChange={onChange}
                value={value.outletType}
                required
                helperText={error["outletType"]}
                data={OUTLET_TYPES}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="email"
                label="Email"
                onChange={onChange}
                placeholder="Enter Email"
                value={value.email}
                required={false}
                helperText={error["email"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <TextfieldWithImage
                inputName="phoneNumber"
                selectName="countryCode"
                label="Phone Number"
                placeholder="Enter phone number"
                onChange={onChange}
                inputValue={value.phoneNumber}
                selectValue={value.countryCode}
                required={false}
                helperText={error["phoneNumber"]}
                imageLink={
                  value.countryCode === ""
                    ? require(`../../assets/images/flags/qa.png`)
                    : getFlagName(value.countryCode)
                }
                selectData={countryCodeData}
                type={"dropdown"}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <TextArea
                label="Outlet Information"
                placeholder="About Outlet"
                onChange={onChange}
                value={value.outletInfo}
                name="outletInfo"
                required
                helperText={error["outletInfo"]}
                rows={14}
              />
            </FieldWrapper>
            <FieldWrapper>
              <TextfieldWithImage
                inputName="whatsappNumber"
                label="Connect"
                placeholder="Enter Whatsapp Number"
                onChange={onChange}
                inputValue={value.whatsappNumber}
                required={false}
                helperText={error["whatsappNumber"]}
                imageLink={require(`../../assets/images/img_whatsapp.png`)}
                type="image"
              />
              <Gap height="6px" />
              <TextfieldWithImage
                inputName="instaLink"
                placeholder="Enter Instagram Link"
                onChange={onChange}
                inputValue={value.instaLink}
                required={false}
                helperText={error["instaLink"]}
                imageLink={require(`../../assets/images/img_insta.png`)}
                type="image"
              />
              <Gap height="6px" />
              <TextfieldWithImage
                inputName="fbLink"
                placeholder="Enter Facebook Link"
                onChange={onChange}
                inputValue={value.fbLink}
                required={false}
                helperText={error["fbLink"]}
                imageLink={require(`../../assets/images/img_fb.png`)}
                type="image"
              />
              <Gap height="6px" />
              <TextfieldWithImage
                inputName="tripAdvisor"
                placeholder="Enter Trip Advisor Link"
                onChange={onChange}
                inputValue={value.tripAdvisor}
                required={false}
                imageLink={require(`../../assets/images/img_tripadvisor.png`)}
                helperText={error["tripAdvisor"]}
                type="image"
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="lat"
                label="Outlet location"
                placeholder="Add Latitude"
                onChange={onChange}
                value={value.lat}
                required
                helperText={error["lat"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Gap height="24px" height2="0px" />
              <Textfield
                name="long"
                placeholder="Add Longitude"
                onChange={onChange}
                value={value.long}
                required
                helperText={error["long"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="address"
                label="Outlet Address"
                placeholder="Enter Outlet Address"
                onChange={onChange}
                value={value.address}
                required
                helperText={error["address"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="shortName"
                label="Short Name"
                placeholder="Enter outlet short name"
                onChange={onChange}
                value={value.shortName}
                required={false}
                helperText={error["shortName"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Datefield
                name="startDate"
                label="Start Date"
                onChange={onChange}
                placeholder="Select date"
                value={value.startDate}
                required
                helperText={error["startDate"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Datefield
                name="endDate"
                label="End Date"
                onChange={onChange}
                placeholder="Select date"
                value={value.endDate}
                required
                helperText={error["endDate"]}
              />
            </FieldWrapper>
          </FormRow>
          {/* <FormRow>
            <FieldWrapper>
              <MultiDateSelector
                fullWidth
                label="Special Product Dates"
                placeholder="Select Dates"
                onDateSelect={onChange}
                required={false}
                helperText={""}
                name="specialProductsDates"
                value={value.specialProductsDates}
              />
            </FieldWrapper>
            <FieldWrapper>
              <MultiDateSelector
                label="Holiday Bookings Allowed Dates"
                fullWidth
                placeholder="Select Date"
                onDateSelect={onChange}
                required={false}
                helperText={""}
                name="holidayAllowedDates"
                value={value.holidayAllowedDates.map((dates)=>dates.replaceAll('-','/'))}
              />
            </FieldWrapper>
          </FormRow> */}

          {/* <FormRow> */}
          {/* <FieldWrapper>
              <MultiDateSelector
                fullWidth
                label="Restricted Dates"
                placeholder="Select Dates"
                onDateSelect={onChange}
                required={false}
                helperText={""}
                name="restrictedDates"
                value={value.restrictedDates.map((dates)=>dates.replaceAll('-','/'))}
              />
            </FieldWrapper> */}

          {/* </FormRow> */}
          <FormRow>
            <FieldWrapper>
              <MultiTagSelector
                error={error?.tags}
                label="Tags"
                data={outletTags}
                selected={value?.tags}
                onToggleOption={onToggleTagOption}
                onToggleSelectAll={onToggleSelectAllTags}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="surveyLink"
                label="Survey Link"
                placeholder="Enter link"
                onChange={onChange}
                value={value.surveyLink}
                required={false}
                helperText={error["surveyLink"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="costCenter"
                label="Cost Center"
                placeholder="Enter cost center"
                onChange={onChange}
                value={value.costCenter}
                required
                helperText={error["costCenter"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="companyCode"
                label="Company Code"
                placeholder="Enter company code"
                onChange={onChange}
                value={value.companyCode}
                required
                helperText={error["companyCode"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                type="number"
                name="order"
                label="Order"
                placeholder="Enter order"
                onChange={onChange}
                value={value.order}
                helperText={error["order"]}
              />
            </FieldWrapper>
            <FieldWrapper></FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <UploadOutletImages
                name="logoUrl"
                label="Upload Outlet Logo"
                onChange={onChange}
                onRemove={onRemove}
                required
                uploadedImage={uploadedImage}
                helperText={error["logoUrl"]}
                maxImages={1}
                subLabel="Only JPEG or PNG files are allowed. Max size: 2MB. Recommended dimensions:512x512"
                urls={value.logoUrl}
                acceptFormats=".jpeg, .jpg, .png"
              />
            </FieldWrapper>
            <FieldWrapper>
              <UploadOutletImages
                name="imageUrl"
                label="Upload Outlet image"
                onChange={onChange}
                onRemove={onRemove}
                required
                uploadedImage={uploadedImage}
                helperText={error["imageUrl"]}
                maxImages={5}
                subLabel="Only JPEG or PNG files are allowed. Max size: 2MB. Recommended dimensions: 672x378."
                urls={value.imageUrl}
                acceptFormats=".jpeg, .jpg, .png"
                onSetUrls={onSetUrls}
              />
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              {value?.tcLink ? (
                <>
                  <MenuContainer>
                    <div>
                      <div>terms_condition.pdf</div>
                    </div>
                    <div>
                      <a href={value?.tcLink}>Download</a>
                      <div
                        onClick={() => {
                          // @ts-ignore
                          onChange({ target: { value: "", name: "tcLink" } });
                        }}
                        className="action"
                      >
                        Delete
                      </div>
                      <ActionButton>
                        Replace
                        <input
                          accept="application/pdf"
                          type="file"
                          name="tcLink"
                          onChange={(e: any) => {
                            onChange(e);
                          }}
                        />
                      </ActionButton>
                    </div>
                  </MenuContainer>
                </>
              ) : (
                <>
                  <MenuContainer>
                    <div>
                      <div
                        style={{ color: Colors.cloudyGrey, fontSize: "12px" }}
                      >
                        Terms & Conditions Not Selected (Select PDF with Max.
                        2MB)
                      </div>
                    </div>
                    <div>
                      <ActionButton>
                        Choose PDF
                        <input
                          accept="application/pdf"
                          type="file"
                          name="tcLink"
                          onChange={(e: any) => {
                            onChange(e);
                          }}
                        />
                      </ActionButton>
                    </div>
                  </MenuContainer>
                </>
              )}
            </FieldWrapper>
            <FieldWrapper>
              {value?.ppLink ? (
                <>
                  <MenuContainer>
                    <div>
                      <div>privacy_policy.pdf</div>
                    </div>
                    <div>
                      <a href={value?.ppLink}>Download</a>
                      <div
                        onClick={() => {
                          // @ts-ignore
                          onChange({ target: { value: "", name: "ppLink" } });
                        }}
                        className="action"
                      >
                        Delete
                      </div>
                      <ActionButton>
                        Replace
                        <input
                          accept="application/pdf"
                          type="file"
                          name="ppLink"
                          onChange={(e: any) => {
                            onChange(e);
                          }}
                        />
                      </ActionButton>
                    </div>
                  </MenuContainer>
                </>
              ) : (
                <>
                  <MenuContainer>
                    <div>
                      <div
                        style={{ color: Colors.cloudyGrey, fontSize: "12px" }}
                      >
                        Privacy Policy Not Selected (Select PDF with Max. 2MB)
                      </div>
                    </div>
                    <div>
                      <ActionButton>
                        Choose PDF
                        <input
                          accept="application/pdf"
                          type="file"
                          name="ppLink"
                          onChange={(e: any) => {
                            onChange(e);
                          }}
                        />
                      </ActionButton>
                    </div>
                  </MenuContainer>
                </>
              )}
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <br />
      {value.outletType === "2" && (
        <>
          <StyledDiv>
            <StyledPageHeader>Top Attraction</StyledPageHeader>
          </StyledDiv>
          <Box>
            <FormWrapper>
              <FormRow>
                <FieldWrapper>
                  <UploadOutletImages
                    name="bannerImageUrl"
                    label="Upload Banner image"
                    onChange={onChange}
                    onRemove={onRemove}
                    required
                    uploadedImage={uploadedImage}
                    helperText={error["bannerImageUrl"]}
                    maxImages={1}
                    subLabel="Only JPEG or PNG files are allowed. Max size: 2MB. Recommended dimensions: 327x106."
                    urls={value.bannerImageUrl}
                    acceptFormats=".jpeg, .jpg, .png"
                  />
                </FieldWrapper>
              </FormRow>
            </FormWrapper>
          </Box>
        </>
      )}
      <br />
      <StyledDiv>
        <StyledPageHeader>Reservation</StyledPageHeader>
        <InfoWrapper>
          <InfoAndText
            text={"(This toggle is to Enable and Disable the Reservation)"}
          />
          <StyledStatus>
            <GreenOrGray status={reservationStatus} statusType={"disable"}>
              Disable
            </GreenOrGray>
            <Toggle
              uniqueName={"reservationStatus"}
              isChecked={reservationStatus}
              onChange={reservationToggle}
            />
            <GreenOrGray status={reservationStatus} statusType={"enable"}>
              Enable
            </GreenOrGray>
          </StyledStatus>
        </InfoWrapper>
      </StyledDiv>
      <Gap height="0px" height2="2rem" />
      <div>
        <Radio
          index={0}
          label="Seven room"
          selected={isSelectedRadio[0]}
          onChange={handleRadio}
          name="sevenRoom"
        />
        <Radio
          index={1}
          label="Non seven room"
          selected={isSelectedRadio[1]}
          onChange={handleRadio}
          name="sevenRoom"
        />
      </div>
      <Box>
        <FormWrapper>
          {!isSevenRoomBooking && (
            <FormRow>
              <FieldWrapper>
                <Textfield
                  name="sevenRoomWhatsapp"
                  label="Reservation Whatsapp"
                  placeholder="Enter Whatsapp Number"
                  onChange={onChange}
                  value={value.sevenRoomWhatsapp}
                  required={false}
                  helperText={error["sevenRoomWhatsapp"]}
                />
              </FieldWrapper>
              <FieldWrapper>
                <TextfieldWithImage
                  inputName="sevenRoomContact"
                  selectName="sevenRoomCountryCode"
                  label="Reservation Contact Number"
                  placeholder="Enter phone number"
                  onChange={onChange}
                  inputValue={value.sevenRoomContact}
                  selectValue={value.sevenRoomCountryCode}
                  required={false}
                  helperText={error["sevenRoomContact"]}
                  imageLink={
                    value.sevenRoomCountryCode === ""
                      ? require(`../../assets/images/flags/qa.png`)
                      : getFlagName(value.sevenRoomCountryCode)
                  }
                  selectData={countryCodeData}
                  type={"dropdown"}
                />
              </FieldWrapper>
            </FormRow>
          )}
          {isSevenRoomBooking && (
            <FormRow>
              <FieldWrapper>
                <Textfield
                  name="maxGuest"
                  label="Maximum Guest Limit Number"
                  placeholder="Enter max guest limit"
                  onChange={onChange}
                  value={value.maxGuest}
                  required
                  helperText={error["maxGuest"]}
                />
              </FieldWrapper>
              <FieldWrapper>
                <Textfield
                  name="venueId"
                  label="Venue ID"
                  placeholder="Enter venue ID"
                  onChange={onChange}
                  value={value.venueId}
                  required
                  helperText={error["venueId"]}
                />
              </FieldWrapper>
            </FormRow>
          )}
        </FormWrapper>
      </Box>
      <br />
      {/* <StyledDiv>
        <StyledPageHeader>Tax Configuration</StyledPageHeader>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <InfoWrapper>
            <InfoAndText text={"(This toggle is to enable tax)"} />
            <StyledStatus>
              <GreenOrGray status={value?.isTaxEnabled} statusType={"disable"}>
                Disabled
              </GreenOrGray>
              <Toggle
                uniqueName={"isTaxEnabled"}
                isChecked={value?.isTaxEnabled}
                onChange={() =>
                  onChange({
                    target: {
                      value: !value?.isTaxEnabled,
                      name: "isTaxEnabled",
                    },
                  })
                }
              />
              <GreenOrGray status={value?.isTaxEnabled} statusType={"enable"}>
                Enabled
              </GreenOrGray>
            </StyledStatus>
          </InfoWrapper>
          <InfoWrapper disabled={!value?.isTaxEnabled}>
            <InfoAndText
              text={
                "(This toggle if true means inclusive VAT, false means Add-on VAT)"
              }
            />
            <StyledStatus>
              <GreenOrGray
                status={value?.isInclusiveVAT}
                statusType={"disable"}
              >
                Add-on VAT
              </GreenOrGray>
              <Toggle
                uniqueName={"isInclusiveVAT"}
                isChecked={value?.isInclusiveVAT}
                onChange={() =>
                  onChange({
                    target: {
                      value: !value?.isInclusiveVAT,
                      name: "isInclusiveVAT",
                    },
                  })
                }
              />
              <GreenOrGray status={value?.isInclusiveVAT} statusType={"enable"}>
                Inclusive
              </GreenOrGray>
            </StyledStatus>
          </InfoWrapper>
        </div>
      </StyledDiv> */}

      {/* <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Selectfield
                name="taxType"
                label="Tax Config"
                onChange={onChange}
                value={value.taxType}
                helperText={error["taxType"]}
                data={taxConfigList}
                disabled={!value?.isTaxEnabled}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="trn"
                label="TRN"
                placeholder="Enter TRN"
                onChange={onChange}
                value={value.trn}
                helperText={error["trn"]}
                disabled={!value?.isTaxEnabled}

              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="crNumber"
                label="CR Number"
                placeholder="Enter CR Number"
                onChange={onChange}
                value={value.crNumber}
                helperText={error["crNumber"]}
                disabled={!value?.isTaxEnabled}

              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="groupTrn"
                label="Group TRN"
                placeholder="Enter Group TRN"
                onChange={onChange}
                value={value.groupTrn}
                helperText={error["groupTrn"]}
                disabled={!value?.isTaxEnabled}

              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="tin"
                label="TIN"
                placeholder="Enter TIN"
                onChange={onChange}
                value={value.tin}
                helperText={error["tin"]}
                disabled={!value?.isTaxEnabled}

              />
            </FieldWrapper>
            <FieldWrapper>
              <Datefield
                name="taxStartDate"
                label="Tax Start Date"
                onChange={onChange}
                placeholder="Tax Start Date"
                value={value.taxStartDate}
                helperText={error["taxStartDate"]}
                disabled={!value?.isTaxEnabled}

              />
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <br /> */}
      <StyledDiv>
        <StyledPageHeader>iFrame Booking</StyledPageHeader>
        <InfoWrapper>
          <InfoAndText
            text={
              "( This toggle is to switch the Web iFrame Booking to App Booking )"
            }
          />
          <StyledStatus>
            <GreenOrGray status={isIFrameBooking} statusType={"disable"}>
              App
            </GreenOrGray>
            <Toggle
              uniqueName={"isIFrameBooking"}
              isChecked={isIFrameBooking}
              onChange={setIsIFrameBooking}
            />
            <GreenOrGray status={isIFrameBooking} statusType={"enable"}>
              Web
            </GreenOrGray>
          </StyledStatus>
        </InfoWrapper>
      </StyledDiv>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="iFrameUrl"
                label="iFrame URL"
                placeholder="Enter URL"
                onChange={onChange}
                value={value.iFrameUrl}
                required={isIFrameBooking}
                helperText={error["iFrameUrl"]}
              />
            </FieldWrapper>
            <FieldWrapper></FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <br />
      <StyledDiv>
        <StyledPageHeader>Loyalty Configuration</StyledPageHeader>
        <InfoWrapper>
          <InfoAndText text="(This toggle is to activate and deactivate Loyalty)" />
          <StyledStatus>
            Status:
            <Toggle
              uniqueName={"isLoyaltyEnabled"}
              isChecked={value?.isLoyaltyEnabled}
              onChange={setIfLoyaltyEnabled}
            />
            <ActiveDeactive status={value?.isLoyaltyEnabled}>
              {value?.isLoyaltyEnabled ? "Active" : "Inactive"}
            </ActiveDeactive>
          </StyledStatus>
        </InfoWrapper>
      </StyledDiv>
      <Box>
        <FormWrapper>
          <StyledSectionHeader>Loyalty Type</StyledSectionHeader>

          <FormRow>
            <div>
              <div style={{ display: "flex", gap: "1.5rem" }}>
                <Checkbox
                  label="Online"
                  isChecked={value?.loyaltyTypes.includes("online")}
                  onChange={onLoyaltyTypeChange}
                  value={"online"}
                />
                <Checkbox
                  label="Manual"
                  isChecked={value?.loyaltyTypes.includes("manual")}
                  onChange={onLoyaltyTypeChange}
                  value={"manual"}
                />
                <Checkbox
                  label="POS"
                  isChecked={value?.loyaltyTypes.includes("pos")}
                  onChange={onLoyaltyTypeChange}
                  value={"pos"}
                />
                <Checkbox
                  label="Scan"
                  isChecked={value?.loyaltyTypes.includes("scan")}
                  onChange={onLoyaltyTypeChange}
                  value={"scan"}
                />
              </div>
              <div>
                {error?.loyaltyTypes && <Error>{error?.loyaltyTypes}</Error>}
              </div>
            </div>
          </FormRow>
          {value.loyaltyTypes.includes("pos") && (
            <StyledSectionHeader>POS Configuration</StyledSectionHeader>
          )}

          {value.loyaltyTypes.includes("pos") && (
            <>
              <FormRow>
                <FieldWrapper>
                  <Textfield
                    required={
                      value.loyaltyTypes.includes("pos") &&
                      value.isLoyaltyEnabled
                    }
                    name="posConfigUrl"
                    label="URL"
                    placeholder="Enter URL"
                    onChange={onChange}
                    value={value.posConfigUrl}
                    helperText={error["posConfigUrl"]}
                  />
                </FieldWrapper>
                <FieldWrapper>
                  <Textfield
                    required={
                      value.loyaltyTypes.includes("pos") &&
                      value.isLoyaltyEnabled
                    }
                    type="number"
                    name="posConfigtenderMediaLoyalty"
                    label="Tender Media Loyalty"
                    placeholder="Enter Tender Media Loyalty"
                    onChange={onChange}
                    value={value.posConfigtenderMediaLoyalty}
                    helperText={error["posConfigtenderMediaLoyalty"]}
                  />
                </FieldWrapper>
              </FormRow>
            </>
          )}
          {value.loyaltyTypes.includes("scan") && (
            <>
              <FormRow>
                <FieldWrapper>
                  <Textfield
                    required={
                      value.loyaltyTypes.includes("scan") &&
                      value.isLoyaltyEnabled
                    }
                    name="receiptMerchantName"
                    label="Merchant Name"
                    placeholder="Enter merchant name"
                    onChange={onChange}
                    value={value.receiptMerchantName}
                    helperText={error["receiptMerchantName"]}
                  />
                </FieldWrapper>
                <FieldWrapper></FieldWrapper>
              </FormRow>
            </>
          )}

          {value.loyaltyTypes.includes("pos") && (
            <>
              <FormRow>
                <FieldWrapper>
                  <Textfield
                    required={
                      value.loyaltyTypes.includes("pos") &&
                      value.isLoyaltyEnabled
                    }
                    name="posConfigempId"
                    label="Employee ID"
                    placeholder="Enter employee ID"
                    onChange={onChange}
                    value={value.posConfigempId}
                    helperText={error["posConfigempId"]}
                  />
                </FieldWrapper>
                <FieldWrapper>
                  <Textfield
                    required={
                      value.loyaltyTypes.includes("pos") &&
                      value.isLoyaltyEnabled
                    }
                    type="number"
                    name="posConfigrevCenter"
                    label="Revenue Center"
                    placeholder="Enter Revenue Center"
                    onChange={onChange}
                    value={value.posConfigrevCenter}
                    helperText={error["posConfigrevCenter"]}
                  />
                </FieldWrapper>
              </FormRow>
            </>
          )}
          {value.loyaltyTypes.includes("pos") && (
            <>
              <FormRow>
                <FieldWrapper>
                  <Textfield
                    required={
                      value.loyaltyTypes.includes("pos") &&
                      value.isLoyaltyEnabled
                    }
                    name="notificationEmail"
                    label="Notification Email"
                    placeholder="Enter Email ID"
                    onChange={onChange}
                    value={value.notificationEmail}
                    helperText={error["notificationEmail"]}
                  />
                </FieldWrapper>
                <FieldWrapper></FieldWrapper>
              </FormRow>
            </>
          )}
        </FormWrapper>
      </Box>
      <ActionRow>
        <ButtonWrapper>
          <Button
            variant="outlined"
            label="Cancel"
            onClick={onCancel}
            width="9.7rem"
          />
          <Button
            color={Colors.red}
            variant="filled"
            label="Save"
            onClick={onSubmit}
            width="9.7rem"
          />
        </ButtonWrapper>
      </ActionRow>
    </Container>
  );
};

interface GapProps {
  height: string;
  height2?: string;
}

const FieldWrapper = styled.div`
  flex: 1;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
    margin-top: 2rem;
  }
  @media only screen and (max-width: 350px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

const ActionRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

const FormRow = styled.div`
  display: flex;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const Container = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;
export const Gap = styled.div<GapProps>`
  height: ${(GapProps) => GapProps.height};
  @media only screen and (max-width: 768px) {
    height: ${(GapProps) =>
      GapProps.height2 ? GapProps.height2 : GapProps.height};
  }
`;
const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    margin-left: 1rem;
  }
`;

const StyledSectionHeader = styled.div`
  font-size: 1rem;
  font-family: "Poppins-Medium";
  // line-height: 1.75rem;
  color: ${Colors.santasGray};
  @media only screen and (max-width: 768px) {
    margin-left: 1rem;
  }
`;

const StyledStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8125rem;
`;
const GreenOrGray = styled.div<StatusProps>`
  color: ${(props) =>
    props.status
      ? props.statusType === "disable"
        ? Colors.silver
        : Colors.appleGreen
      : props.statusType === "disable"
      ? Colors.appleGreen
      : Colors.silver};
`;
export const ActiveDeactive = styled.div<StatusProps>`
  color: ${(props) => (props.status ? Colors.appleGreen : Colors.appleRed)};
  width: 6rem;
`;

const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

const MenuContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 10px 0;
  align-items: center;
  font-size: 14px;
  border: 1px solid lightgrey;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 8px;
  > div {
    display: flex;
    gap: 1rem;
    align-items: center;
  }
  a {
    color: #ff2e2e; /* red */
    text-decoration: none;
    font-weight: 600;

    &:hover {
      color: #ff5555;
      text-decoration: underline;
    }
  }

  .action {
    // margin: 0px 8px;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    background: #ff0000ff;
    color: white;
    transition: 0.2s ease;
    border: 1px solid #ff2e2e;

    &:hover {
      color: #ff2e2e;
      background: white;
      border: 1px solid #ff2e2e;
    }
  }
`;

export const ActionButton = styled.label`
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  background: #ff0000ff;
  color: white;
  transition: 0.2s ease;
  border: 1px solid #ff2e2e;

  &:hover {
    color: #ff2e2e;
    background: white;
    border: 1px solid #ff2e2e;
  }

  input {
    display: none;
  }
`;

export default AddOutletForm;
